function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin-left: auto;\n  padding: ", ";\n  margin-top: ", ";\n  margin-bottom: ", ";\n  margin-right: ", ";\n  cursor: pointer;\n  border: none;\n  background-color: transparent;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';
import Delete from '../Icons/Delete';
import { px2rem } from '../../utils/helpers';
var CloseButton = styled.button(_templateObject(), px2rem(10), px2rem(-10), px2rem(-10), px2rem(20));
var ModalCloseButton = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(CloseButton, _extends({
    ref: ref,
    type: "button"
  }, props), /*#__PURE__*/React.createElement(Delete, {
    size: 15
  }));
});
export default ModalCloseButton;